import { SSO_URL } from '../../../config'

export const doSsoRedirect = () => {
  const searchParams = new URLSearchParams({ appName: 'hof', sso_return: location.href })
  location.replace(`${SSO_URL}?${searchParams.toString()}`)
}
